import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export function useIsAuthenticated() {
	const queryClient = useQueryClient();
	const { data } = useSuspenseQuery({
		queryKey: QueryKeys.AuthCheck(),
		queryFn: () =>
			Api.Profile()
				.then((x) => {
					queryClient.setQueryData(QueryKeys.Profile(), x.data);
					return x.data;
				})
				.catch((e) => {
					if (isAxiosError(e) && e.response?.status === 401) {
						// Handle log our/log in requirement
						return null;
					}

					throw e;
				}),
	});

	return data !== null;
}
